import { EvaneosThemeProvider } from '@evaneos/b2b-ui';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Userpilot } from 'userpilot';

import '../../../styles/reset.global.css';
import '../../../styles/react-components.global.css';
import '../../../styles/third-party-libraries.global.css';
import '../../../styles/z-index.global.css';
import '@evaneos/b2b-ui/index.css';
// to delete when the new brand colors are in B2B-UI
import '../../../styles/colors-rebranding.global.css';

import { Notifications } from '../../../design-system/Notifications';
import { TranscriptStatusNotification } from '../../../pages/Dossier/Phoning/TranscriptNotification/TranscriptStatusNotification';
import { TranscriptGenerationProvider } from '../../providers/TranscriptGenerationProvider';
import { FiltersDrawerProvider } from '../../providers/FiltersDrawerContext';
import { Routes } from '../../routing/Routes';
import { setTheme, toastConfig } from '../../../styles/theme';
import { AppErrorBoundary } from '../ErrorBoundary/AppErrorBoundary';

import s from './app.module.css';
import { CalendarConnectBanner } from './CalendarConnectBanner';
import { LayoutNavbar } from './Navbar';

const Layout = (): JSX.Element => {
    const location = useLocation();

    useEffect(() => {
        Userpilot.reload();
    }, [location]);

    return (
        <EvaneosThemeProvider rootHtmlFontSize={10} setTheme={setTheme} toastConfig={toastConfig}>
            <TranscriptGenerationProvider>
                <FiltersDrawerProvider>
                    <div id="app-container" className={s.appContainer}>
                        <CalendarConnectBanner />
                        <LayoutNavbar />
                        <main className={s.children}>
                            <AppErrorBoundary key={location.pathname}>
                                <Routes />
                            </AppErrorBoundary>
                        </main>
                        <Notifications />
                        <TranscriptStatusNotification />
                    </div>
                </FiltersDrawerProvider>
            </TranscriptGenerationProvider>
        </EvaneosThemeProvider>
    );
};

Layout.displayName = 'AppLayout';

export { Layout as AppLayout };
